"use strict";

/* global document, window */

var SELECTORS = {
  animate: "[data-animate]",
  offer: ".bf-offer",
  countdownValue: "[data-unit]",
  progressBar: "[data-progress-bar]",
  inventory: "[data-inventory]",
};

function revealElements() {
  var elements = document.querySelectorAll(SELECTORS.animate);
  var index = 0;
  while (index < elements.length) {
    elements[index].classList.add("is-visible");
    index += 1;
  }
}

function pad(value) {
  if (value < 10) {
    return "0" + value;
  }
  return String(value);
}

function getTimeParts(distance) {
  var totalSeconds = Math.max(Math.floor(distance / 1000), 0);
  return {
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  };
}

function setInventory(total, reserved, inventoryLabel, progressBar) {
  if (!inventoryLabel && !progressBar) {
    return;
  }

  var remaining = total - reserved;
  if (remaining < 0) {
    remaining = 0;
  }

  if (inventoryLabel) {
    inventoryLabel.textContent = remaining + " of " + total + " pieces remain";
  }

  if (progressBar) {
    var percent = 0;
    if (total > 0) {
      percent = (reserved / total) * 100;
    }
    if (percent > 100) {
      percent = 100;
    }
    progressBar.style.width = percent + "%";
  }
}

function initCountdown() {
  var offer = document.querySelector(SELECTORS.offer);
  if (!offer) {
    return;
  }

  var saleEndAttr = offer.getAttribute("data-sale-end");
  var total = Number(offer.getAttribute("data-total") || 0);
  var reserved = Number(offer.getAttribute("data-reserved") || 0);

  var values = offer.querySelectorAll(SELECTORS.countdownValue);
  var progressBar = offer.querySelector(SELECTORS.progressBar);
  var inventoryLabel = offer.querySelector(SELECTORS.inventory);

  setInventory(total, reserved, inventoryLabel, progressBar);

  if (!saleEndAttr) {
    var idx = 0;
    while (idx < values.length) {
      var valueNode = values[idx];
      var unit = valueNode.getAttribute("data-unit");
      valueNode.textContent = unit === "days" ? "--" : "00";
      idx += 1;
    }
    return;
  }

  var saleEndDate = new Date(saleEndAttr);
  if (isNaN(saleEndDate.getTime())) {
    var resetIndex = 0;
    while (resetIndex < values.length) {
      values[resetIndex].textContent = "00";
      resetIndex += 1;
    }
    return;
  }

  function render() {
    var distance = saleEndDate.getTime() - Date.now();
    var parts = getTimeParts(distance);
    var nodeIndex = 0;

    while (nodeIndex < values.length) {
      var node = values[nodeIndex];
      var unit = node.getAttribute("data-unit");
      if (unit === "days") {
        node.textContent = pad(parts.days);
      } else if (unit === "hours") {
        node.textContent = pad(parts.hours);
      } else if (unit === "minutes") {
        node.textContent = pad(parts.minutes);
      } else if (unit === "seconds") {
        node.textContent = pad(parts.seconds);
      }
      nodeIndex += 1;
    }

    if (distance <= 0) {
      window.clearInterval(timerId);
    }
  }

  render();
  var timerId = window.setInterval(render, 1000);
}

function initHeroCarousel() {
  var scroller = document.querySelector(".bf-collection__scroller");
  if (!scroller) {
    return;
  }

  var mobileQuery = window.matchMedia("(max-width: 767px)");
  if (mobileQuery.matches) {
    if (!scroller.dataset.carouselListenerAttached) {
      var onChange = function (event) {
        if (!event.matches) {
          if (mobileQuery.removeEventListener) {
            mobileQuery.removeEventListener("change", onChange);
          } else if (mobileQuery.removeListener) {
            mobileQuery.removeListener(onChange);
          }
          delete scroller.dataset.carouselListenerAttached;
          initHeroCarousel();
        }
      };
      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener("change", onChange);
      } else if (mobileQuery.addListener) {
        mobileQuery.addListener(onChange);
      }
      scroller.dataset.carouselListenerAttached = "true";
    }
    return;
  }

  if (scroller.dataset.autoplay === "true") {
    return;
  }

  var cards = scroller.querySelectorAll(".bf-card--carousel");
  if (!cards.length) {
    return;
  }

  var originals = Array.prototype.slice.call(cards);
  var baseWidth = scroller.scrollWidth;
  var fragment = document.createDocumentFragment();
  var i = 0;
  while (i < originals.length) {
    fragment.appendChild(originals[i].cloneNode(true));
    i += 1;
  }
  scroller.appendChild(fragment);
  scroller.dataset.autoplay = "true";

  var speed = 0.35;
  var position = 0;
  var paused = false;
  var raf =
    window.requestAnimationFrame ||
    function (callback) {
      return window.setTimeout(callback, 16);
    };

  scroller.addEventListener("mouseenter", function () {
    paused = true;
  });

  scroller.addEventListener("mouseleave", function () {
    paused = false;
  });

  function step() {
    if (!paused) {
      position += speed;
      if (position >= baseWidth) {
        position = position - baseWidth;
      }
      scroller.scrollLeft = position;
    }
    raf(step);
  }

  raf(step);
}

document.addEventListener("DOMContentLoaded", function () {
  revealElements();
  initCountdown();
  initHeroCarousel();
});
